import React, { useRef } from 'react';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { useT } from '@features/oneOnboarding/hooks/useT';
import { OOControlModelInterface } from '@features/oneOnboarding/interfaces';
import { useFaceVerifySDK } from '@features/oneOnboarding/pages/DataCheckerUpload/dataCheckerSDK';
import LoadingButton from '@mui/lab/LoadingButton';
import { Box } from '@mui/material';

type DCSdkButtonProps = {
  controlModel: OOControlModelInterface;
  setSdkSuccess: any;
  setSdkError: any;
  setSdkCapturedDocument: any;
};

export const DCSdkButton: React.FC<DCSdkButtonProps> = ({
  controlModel,
  setSdkSuccess,
  setSdkError,
  setSdkCapturedDocument,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const faceVerifySDK = useFaceVerifySDK();
  const { t } = useT('entry');

  return (
    <Box pt={1}>
      <div id="autocapture-container" ref={containerRef} style={{ width: '100%', height: '100%', zIndex: 10000 }} />
      <LoadingButton
        variant="contained"
        color="primary"
        type="button"
        style={{ marginTop: '100px' }}
        onClick={() => faceVerifySDK(containerRef, setSdkSuccess, setSdkError, setSdkCapturedDocument)}
      >
        {t(controlModel.label)}
      </LoadingButton>
    </Box>
  );
};
